!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.pl = t());
}(this, function () {
  "use strict";

  return [{
    locale: "pl",
    pluralRuleFunction: function pluralRuleFunction(e, t) {
      var a = String(e).split("."),
          i = a[0],
          n = !a[1],
          m = i.slice(-1),
          u = i.slice(-2);
      return t ? "other" : 1 == e && n ? "one" : n && m >= 2 && m <= 4 && (u < 12 || u > 14) ? "few" : n && 1 != i && (0 == m || 1 == m) || n && m >= 5 && m <= 9 || n && u >= 12 && u <= 14 ? "many" : "other";
    },
    fields: {
      year: {
        displayName: "rok",
        relative: {
          0: "w tym roku",
          1: "w przyszłym roku",
          "-1": "w zeszłym roku"
        },
        relativeTime: {
          future: {
            one: "za {0} rok",
            few: "za {0} lata",
            many: "za {0} lat",
            other: "za {0} roku"
          },
          past: {
            one: "{0} rok temu",
            few: "{0} lata temu",
            many: "{0} lat temu",
            other: "{0} roku temu"
          }
        }
      },
      month: {
        displayName: "miesiąc",
        relative: {
          0: "w tym miesiącu",
          1: "w przyszłym miesiącu",
          "-1": "w zeszłym miesiącu"
        },
        relativeTime: {
          future: {
            one: "za {0} miesiąc",
            few: "za {0} miesiące",
            many: "za {0} miesięcy",
            other: "za {0} miesiąca"
          },
          past: {
            one: "{0} miesiąc temu",
            few: "{0} miesiące temu",
            many: "{0} miesięcy temu",
            other: "{0} miesiąca temu"
          }
        }
      },
      day: {
        displayName: "dzień",
        relative: {
          0: "dzisiaj",
          1: "jutro",
          2: "pojutrze",
          "-2": "przedwczoraj",
          "-1": "wczoraj"
        },
        relativeTime: {
          future: {
            one: "za {0} dzień",
            few: "za {0} dni",
            many: "za {0} dni",
            other: "za {0} dnia"
          },
          past: {
            one: "{0} dzień temu",
            few: "{0} dni temu",
            many: "{0} dni temu",
            other: "{0} dnia temu"
          }
        }
      },
      hour: {
        displayName: "godzina",
        relative: {
          0: "ta godzina"
        },
        relativeTime: {
          future: {
            one: "za {0} godzinę",
            few: "za {0} godziny",
            many: "za {0} godzin",
            other: "za {0} godziny"
          },
          past: {
            one: "{0} godzinę temu",
            few: "{0} godziny temu",
            many: "{0} godzin temu",
            other: "{0} godziny temu"
          }
        }
      },
      minute: {
        displayName: "minuta",
        relative: {
          0: "ta minuta"
        },
        relativeTime: {
          future: {
            one: "za {0} minutę",
            few: "za {0} minuty",
            many: "za {0} minut",
            other: "za {0} minuty"
          },
          past: {
            one: "{0} minutę temu",
            few: "{0} minuty temu",
            many: "{0} minut temu",
            other: "{0} minuty temu"
          }
        }
      },
      second: {
        displayName: "sekunda",
        relative: {
          0: "teraz"
        },
        relativeTime: {
          future: {
            one: "za {0} sekundę",
            few: "za {0} sekundy",
            many: "za {0} sekund",
            other: "za {0} sekundy"
          },
          past: {
            one: "{0} sekundę temu",
            few: "{0} sekundy temu",
            many: "{0} sekund temu",
            other: "{0} sekundy temu"
          }
        }
      }
    }
  }];
});